import type { PropsWithChildren } from 'react'
import { cn } from '@/lib/utils'

interface PanelSubtitleProps extends PropsWithChildren {
  className?: string
}

export function PanelSubtitle({ className, children }: PanelSubtitleProps) {
  return (
    <h3
      className={cn(
        'text-2xl font-bold text-[var(--brand-blue-2)] mt-3',
        className
      )}
    >
      {children}
    </h3>
  )
}
